import {
  setAuthentication,
  setAuthUser,
  setGuestLogin,
} from '../features/Authentication/Customer/authUserSlice';
import {
  clearCheckoutAdjustmentDraft,
  getCheckoutSessionScope,
} from '../../utils/checkoutAdjustmentDraft';

const isAuthenticationAction = (action) =>
  setAuthentication.match(action) ||
  setAuthUser.match(action) ||
  setGuestLogin.match(action);

const clearCheckoutSessionDrafts = () => {
  clearCheckoutAdjustmentDraft();

  try {
    if (typeof window === 'undefined' || !window.localStorage) return;
    window.localStorage.removeItem('guestDelivery_address');
    window.localStorage.removeItem('imageName');
  } catch {
    // Storage can be unavailable in private/restricted browser contexts.
  }
};

export const checkoutAdjustmentDraftMiddleware =
  ({ getState }) => {
    let lastKnownSessionScope = getCheckoutSessionScope(
      getState()?.authUser,
    );

    return (next) => (action) => {
      if (!isAuthenticationAction(action)) return next(action);

      const previousSessionScope = lastKnownSessionScope;
      const result = next(action);
      const nextSessionScope = getCheckoutSessionScope(getState()?.authUser);

      if (
        previousSessionScope !== nextSessionScope ||
        (setAuthentication.match(action) && action.payload === false)
      ) {
        clearCheckoutSessionDrafts();
      }

      lastKnownSessionScope = nextSessionScope;
      return result;
    };
  };

export default checkoutAdjustmentDraftMiddleware;
